/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeAtv1EnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_FREE_ATV1_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierFreeAtv1EnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeAtv1EnabledSettingParser.decode(input).map(res => new TierFreeAtv1EnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeAtv1EnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeAtv1EnabledSettingParser.encode(data);
    }
    static schema() {
        return TierFreeAtv1EnabledSettingParser.schema();
    }
}
